import { render, staticRenderFns } from "./booking-pending-approvals-list.vue?vue&type=template&id=37bfdbd8&"
import script from "./booking-pending-approvals-list.vue?vue&type=script&lang=js&"
export * from "./booking-pending-approvals-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VDataTable,VIcon})
